module.exports = __webpack_public_path__ + "img/account-edit.70e7062a.svg";